import baseConfig from './base';

const config = {
  appEnv: 'dist',
  apiBaseUrl: 'https://apibeta.travelappeal.com/customerjourney',
  travelAppealTokenId: '93w1NynjVWie0uLdjkwMQunTgng2mLtwO0xCyUWtQeHQJt42NBOD6cxmzOpWzSsoTZ1rTXVKcDAW7FZUgOyn05JAT8wt1YSUXTmQRiA4Wb13R0Y8OwvOCeownVZoTSjQ',
  apiMock: false,
  google: {
    maps: {
      apiKey: 'AIzaSyB9H6SDNt5tVSESwOrU-e0Wk2PccC5giC0'
    },
    analytics: {
      trackingNumberGA4: 'G-TZWVRMRP33'
    }
  }
};

export default Object.freeze(Object.assign({}, baseConfig, config));



// WEBPACK FOOTER //
// ./config/dist.js